/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { loadFonts } from './webfontloader'
// import vuetify from './vuetify'
import router from '../router'


import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases, mdi } from 'vuetify/iconsets/mdi'

import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader


const vuetify = createVuetify({
  components,
  directives,
  icons: { // https://vuetifyjs.com/en/features/icon-fonts/#mdi-css
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

// Types
import type { App } from 'vue';
//import { defineAsyncComponent } from 'vue';
import AUApi from '@/api';
import { OurPlugin } from "./OurCommonPlugin";
//import { globalsKennung } from '@/local';
//import upperFirst from "lodash/upperFirst";
//import camelCase from "lodash/camelCase";
//import { ImportGlobFunction } from 'vite/types/importGlob';
import Constants from '@/Constants';

declare interface ComponentDefinition {
  name: string;
  component: any;
}
/*
export function importComponents() {
  const modules = import.meta.glob("../editor/*.vue");
  
  for (const path in modules) {
    console.log(path);

    
  }
}

export function importComponent(fileName: any, importFN: any) {
  // Get component config
  //const componentConfig = requireComponent(fileName);
  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Strip the leading `./` and extension from the filename
      fileName.replace(/^\.\/(.*)\.\w+$/, "$1")
    )
  );

  console.log(fileName + " -> " + componentName);
  // Register component globally
  const component = defineAsyncComponent(() =>  import(fileName));
  return {name: componentName, component };
}*/


export function registerPlugins (app: App) {
  loadFonts()

  Constants.App = app;

  //importComponents();
  app
    // .use(vuetify) // in Main.ts auch drinnen - daher immer ein warning das dopppelt eingelesen wird!
    .use(router)
    .use(OurPlugin)
    //.use(Globals as any)
  
}
